import Vue from 'vue';
import Router from 'vue-router';
import Top from './views/Top.vue';
import Staff from './views/Staff.vue';
import Recruit from './views/Recruit.vue';
import Contact from './views/Contact.vue';
import Privacy from './views/Privacy.vue';
import VueAnalytics from 'vue-analytics';

Vue.use(Router);

const router = new Router({
  // TODO: あとでなおす
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'top',
      component: Top,
    },
    {
      path: '/staff',
      name: 'staff',
      component: Staff,
    },
    {
      path: '/recruit',
      name: 'recruit',
      component: Recruit,
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact,
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: Privacy,
    },
  ],
});

Vue.use(VueAnalytics, {
  id: 'UA-176572898-1',
  router,
});

export default router;
